export const EnumSexo = () => {
  return [
    { tipo: 'MASCULINO', descricao: 'Masculino' },
    { tipo: 'FEMININO', descricao: 'Feminino' },
    { tipo: 'AMBOS', descricao: 'Ambos' },
  ];
};
